import { useEffect, useMemo, useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Stack,
} from "@chakra-ui/react";
import { Form, Formik, FormikHelpers } from "formik";
import { IDevice, IDoorLock } from "interfaces/device";
import { object } from "yup";
import { requiredString } from "utils/validationSchema";
import useDoorLock from "hooks/useDoorLock";
import TextInput from "./TextInput";
import Select from "./Select";

interface SmartDoorLockFormModalProps {
  isOpen: boolean;
  onSubmit: (values: IDevice, formikHelpers: FormikHelpers<IDevice>) => void;
  onClose: () => void;
  formValue: IDevice;
  isLoading: boolean;
}

const validationSchema = object({
  label: requiredString,
  config: object({
    lockId: requiredString,
  }),
});

const SmartDoorLockFormModal = ({
  isOpen,
  onClose,
  onSubmit,
  formValue,
  isLoading,
}: SmartDoorLockFormModalProps) => {
  const { getDoorLockList } = useDoorLock();
  const [doorLockList, setDoorLockList] = useState<IDoorLock[]>([]);

  useEffect(() => {
    const getData = async () => {
      const data = await getDoorLockList();
      return data;
    };

    getData().then((value) => {
      setDoorLockList(value);
    });
    // eslint-disable-next-line
  }, []);

  const lockList = useMemo(() => {
    return [
      ...doorLockList.map((item) => ({
        label: item.lockAlias,
        value: item.lockId,
      })),
      {
        label: "--",
        value: "",
      },
    ];
  }, [doorLockList]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Smart Door Lock</ModalHeader>
        <ModalCloseButton />
        <Formik<IDevice>
          initialValues={formValue}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          enableReinitialize
        >
          {({ setFieldValue }) => (
            <Form>
              <ModalBody>
                <Stack spacing={4}>
                  <TextInput label="Label" id="label" name="label" />
                  <Select
                    label="Pilih Door Lock"
                    name="config.lockId"
                    id="lockId"
                    data={lockList}
                    onChange={(e) => {
                      const selected = doorLockList.find(
                        (item) => item.lockId.toString() === e.target.value
                      );
                      console.log(selected, doorLockList, e.target.value);
                      if (selected) {
                        setFieldValue("config.lockData", selected.lockData);
                      }
                    }}
                  />
                </Stack>
              </ModalBody>

              <ModalFooter>
                <Button colorScheme="red" mr={3} onClick={onClose}>
                  Batal
                </Button>
                <Button isLoading={isLoading} colorScheme="blue" type="submit">
                  Simpan
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );
};

export default SmartDoorLockFormModal;
